module.exports = __webpack_public_path__ + "img/united-nations.55afd625.svg";